import React from 'react'

import ClickableLink from 'components/Common/Clickable/ClickableLink'
import StructureLabel from 'components/Luxkit/Label/StructureLabel'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import TextLink from 'components/Luxkit/TextLink'
import noop from 'lib/function/noop'
import { BasicTrip } from 'tripPlanner/types/common'

interface Props {
  trip: BasicTrip
  onClick?: () => void
}

function SavedOfferTripLabel({ trip, onClick = noop }: Props) {
  return (
    <ClickableLink to={`/trip-planner/trip/${trip.id}/summary`}>
      <StructureLabel variant="information">
        <BodyTextBlock variant="small">Added to </BodyTextBlock>
        <TextLink
          size="caption"
          onClick={(e) => {
            e.stopPropagation()
            onClick()
          }}
        >
          {trip.name}
        </TextLink>
      </StructureLabel>
    </ClickableLink>
  )
}

export default SavedOfferTripLabel
